import axios from "axios";


const baseUrl = `${process.env.REACT_APP_BASE_URL}/api`;

let respuesta = {};

// https://eventos.cibnor.mx/registro/apiServiciosSIARF/api/EduconCursosActivos
export const getAllFromEduconCursosActivos = async () => {
    const url = `${ baseUrl }/EduconCursosActivos`;

    await axios.get(url)
    .then((response) => {
        // respuesta.data = response.data;
        // respuesta.exito = 1;
        respuesta = { ...response.data };
    })
    .catch( 
        err => console.log( err )
    );
    return respuesta;
}


export const getOneFromEduconCursosActivos = async (educonSolicitudId) => {
    const url = `${ baseUrl }/EduconCursosActivos`;

    let result = null;

    await axios.get(url)
    .then((response) => {
        const { exito, data } = { ...response.data };
        if (exito == 1) {
            result = data.find(event => event.solicitudID === educonSolicitudId)
        }
    })
    .catch( 
        err => console.log( err )
    );
    return result;
}